import { TemplateRef } from '@angular/core';
import { VehicleGroupsModel } from '@models/vehicle-groups.model';
import {
  CellTemplateContext,
  ColumnBuilder,
  DatasetTableConfig,
  TableConfigBuilder,
  textColumn,
} from '@ui/lib/ui-kit/ui-dataset-table';

export interface CreateSharedWithOrgsTableConfigDependencies {
  actionsCell: TemplateRef<CellTemplateContext<VehicleGroupsModel.VehicleGroupSharedWithRow>>;
}

export function createSharedWithTableConfig(
  dependencies: CreateSharedWithOrgsTableConfigDependencies,
): DatasetTableConfig<VehicleGroupsModel.VehicleGroupSharedWithRow> {
  const builder = new ColumnBuilder<VehicleGroupsModel.VehicleGroupSharedWithRow>();

  return new TableConfigBuilder<VehicleGroupsModel.VehicleGroupSharedWithRow>()
    .columns([
      textColumn<VehicleGroupsModel.VehicleGroupSharedWithRow>(
        'orgName',
        'VEHICLE_GROUPS.SHARE_DIALOG.TABLE.ORGANIZATION',
        {
          width: 'minmax(180px, 1fr)',
          mobileVisible: true,
        },
      ),
      builder
        .column('accessType')
        .label('VEHICLE_GROUPS.SHARE_DIALOG.TABLE.ACTIONS')
        .width('minmax(200px, 260px)')
        .cellTemplate(dependencies.actionsCell)
        .mobileVisible()
        .build(),
    ])
    .rowHeight(44)
    .trackBy('orgId')
    .build();
}
